async function _() {
  const s = `https://sardine.s3-accelerate.cn-east-2.jdcloud-oss.com/${o.bk}.json?timestamp=${(/* @__PURE__ */ new Date()).getTime()}`;
  try {
    const t = await fetch(s, {});
    if (!t.ok)
      throw new Error(`HTTP error! status: ${t.status}`);
    return await t.json();
  } catch (t) {
    throw console.log("Error fetching data:", t), t;
  }
}
async function h() {
  const s = await _();
  s && (window.sardine = s, sessionStorage.setItem("sardine", JSON.stringify(s)), o.status = "loaded");
}
const o = {
  status: !1,
  bk: "jl/jldl"
};
async function y(s) {
  try {
    if (window.sardine || (s && (o.bk = s), o.status === "loading"))
      return;
    o.status = "loading";
    const t = sessionStorage.getItem("sardine");
    if (t)
      try {
        window.sardine = JSON.parse(t), o.status = "loaded";
      } catch (a) {
        console.log("解析存储的沙丁数据异常，重新从接口获取", a), await h();
      }
    else
      await h();
  } catch (t) {
    console.log("沙丁加载异常", t), o.status = "failed";
  } finally {
  }
}
function p(s) {
  var t, a;
  if (s && window.sardine && ((t = window.sardine) != null && t.sgm_custom_ignore_list)) {
    const n = ((a = window.sardine) == null ? void 0 : a.sgm_custom_ignore_list) || [];
    for (const e of n)
      if (s.includes(e))
        return !1;
  }
  return !0;
}
function c(s, { code: t, msg: a, error: n }) {
  var e, f, g;
  try {
    const i = `${a ? `${JSON.stringify(a)}======` : ""}${JSON.stringify(n)}`, w = ((e = n == null ? void 0 : n.response) == null ? void 0 : e.status) || (n == null ? void 0 : n.code), m = ((f = n == null ? void 0 : n.response) == null ? void 0 : f.statusText) || (n == null ? void 0 : n.desc) || (n == null ? void 0 : n.msg) || (n == null ? void 0 : n.message), d = `${t}${w ? `-${w}` : ""}${m ? `-${m}` : ""}`, l = o.status === "loaded" && p(d) || o.status !== "loaded";
    if (console.log("check code", d, l), l && console.log({
      type: s,
      code: d,
      msg: i
    }), $.disabled)
      return;
    (g = window.__sgm__) != null && g.custom && l && window.__sgm__.custom({
      type: s,
      code: d,
      msg: i
    });
  } catch (i) {
    console.error(`Error occurred while sending custom log of type ${s}:`, i);
  }
}
const $ = {
  disabled: !1,
  error(s) {
    c(1, s);
  },
  warning(s) {
    c(2, s);
  },
  info(s) {
    c(3, s);
  },
  log(s) {
    c(4, s);
  }
};
function u(s, ...t) {
  console.log("silentLog", s == null ? void 0 : s.message, ...t);
}
function E(s) {
  if (s != null && s.isResError)
    u(s, "errorHandler");
  else
    throw s;
}
function j(s) {
  if (s != null && s.isResError)
    return u(s, "errorCaptured"), !1;
}
function S(s) {
  var t;
  (t = s == null ? void 0 : s.reason) != null && t.isResError && (u(s.reason, "unhandledrejection"), s.preventDefault());
}
function R(s) {
  return s && (s.isResError = !0, s._message = s.message, s.message = `#api_error#${s.message}`), s;
}
function C() {
  window.addEventListener("unhandledrejection", S);
}
export {
  $ as CustomMonitor,
  j as errorCaptured,
  E as errorHandler,
  _ as getSardine,
  y as loadSardine,
  p as sardineIsReport,
  o as sardineState,
  R as setResError,
  C as setupUnhandled,
  S as unhandledrejection
};
